import { render, staticRenderFns } from "./expire.vue?vue&type=template&id=779771c1&scoped=true&"
import script from "./expire.vue?vue&type=script&lang=js&"
export * from "./expire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779771c1",
  null
  
)

export default component.exports